var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents10" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      !_vm.isMobile
        ? _c("div", { staticClass: "btn-wrap" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=runoil"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_car } }),
                _vm._v(" "),
                _c("span", [_vm._v("카수리 가맹점 문의")]),
                _vm._v(" "),
                _vm._m(2)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=corporate-vehicle"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_carBlue } }),
                _vm._v(" "),
                _c("span", [_vm._v("법인 차량 관리 문의")]),
                _vm._v(" "),
                _vm._m(3)
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isMobile
        ? _c("div", { staticClass: "btn-wrap" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=exterior-repair"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_repair } }),
                _vm._v(" "),
                _c("span", [_vm._v("외장수리 업체 등록 문의")]),
                _vm._v(" "),
                _vm._m(4)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=advertisement"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_mail } }),
                _vm._v(" "),
                _c("span", [_vm._v("광고 / 제휴 문의")]),
                _vm._v(" "),
                _vm._m(5)
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? _c("div", { staticClass: "btn-wrap" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=runoil"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_car } }),
                _vm._v(" "),
                _c("span", [_vm._v("카수리 가맹점 문의")]),
                _vm._v(" "),
                _vm._m(6)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=corporate-vehicle"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_carBlue } }),
                _vm._v(" "),
                _c("span", [_vm._v("법인 차량 관리 문의")]),
                _vm._v(" "),
                _vm._m(7)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=exterior-repair"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_repair } }),
                _vm._v(" "),
                _c("span", [_vm._v("외장수리 업체 등록 문의")]),
                _vm._v(" "),
                _vm._m(8)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    return _vm.gotoPage(
                      "https://www.carsuri.co.kr/contact?tab=advertisement"
                    )
                  }
                }
              },
              [
                _c("img", { attrs: { src: _vm.icon_mail } }),
                _vm._v(" "),
                _c("span", [_vm._v("광고 / 제휴 문의")]),
                _vm._v(" "),
                _vm._m(9)
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "setting-img" }, [
      _c("img", {
        staticClass: "setting",
        attrs: { src: "static/img/icon_setting.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text1" }, [
      _vm._v("\n      새로운 정비 문화를 열어가는"),
      _c("br"),
      _vm._v("\n      자동차 애프터마켓 플랫폼 "),
      _c("span", [_vm._v("카랑")]),
      _vm._v("입니다."),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow" }, [
      _c("img", { attrs: { src: "static/img/btn_arrow_b.png" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55e801ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e801ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents10.vue
// module id = null
// module chunks = 